import React from "react";
import {
  ec1,
  ec2,
  ec3,
  ec4,
  ec5,
  ec6,
  ec7,
  ec8,
  ECommerce,
  ECommerce1,
  ECommerce2,
  ECommerce3,
  ECommerce4,
  ECommerce5,
  newImg7,
} from "../../Assets.tsx";
import { ServiceShell, Section, Hero, Intro, Split, FeatureGrid, Cta } from "../Common-component/ServiceKit";

const services = [
  {
    img: ECommerce1,
    alt: "Product Specifications",
    title: "Product Specifications",
    text: "Our ATUM Information Technology community copywriters create unique, search-engine-optimized product information that contributes to making each of your commodity pages the perfect homepage for both users and engines.",
  },
  {
    img: ECommerce2,
    alt: "Relevance of Search",
    title: "Relevance of Search",
    text: "ATUM Information Technology tests your website's internal search and evaluates search results to optimize your store's technique and usability.",
  },
  {
    img: ECommerce3,
    alt: "Product Classification and Tagging",
    title: "Product Classification and Tagging",
    text: "We provide precise allocation and labeling of each product in your shop assemblage into the relevant product categories using appropriate keywords.",
  },
  {
    img: ECommerce4,
    alt: "Product Data Administration",
    title: "Product Data Administration",
    text: "We extract product data from templates such as image files, PDFs, and print catalogs to ensure that the product information in your online store is always up to date.",
  },
  {
    img: ECommerce5,
    alt: "Tagging of images and videos",
    title: "Tagging of images and videos",
    text: "Allow ATUM Information Technology to tag your images and videos so customers can easily find your content via the internal search function and increase visibility in search engines.",
  },
];

const usps = [
  {
    img: ec1,
    alt: "SEO texts",
    title: "Making SEO texts of extra value",
    text: "ATUM Information Technology increased pertinent and relevant SEO content will benefit you in various ways. By conveying specialist skills and knowledge, insightful texts about your product categories, blog articles, and glossaries can add value. To be rewarded with a high search engine ranking, draw attention to your online store and appropriate link products.",
  },
  {
    img: ec2,
    alt: "Guides and manuals",
    title: "Guides and how-to manuals",
    text: "Order was interestingly written and useful advisory texts about your product and service offerings to provide real added value and expertise to your customers, giving them a reason to return to your website.",
  },
  {
    img: ec3,
    alt: "Market information",
    title: "Market Information Generation",
    text: "For years, online commerce has been booming, increasing competition for you as a store owner. To be successful in the market, you must keep up with the competition and the rapid development of eCommerce. ATUM Information Technology assists you in keeping track of your competitors and their offers, analyzing the market, and gathering consumer data.",
  },
  {
    img: ec4,
    alt: "Analysis of Attitudes",
    title: "Analysis of Attitudes",
    text: "ATUM Information Technology can view and analyze text, video, or audio content to identify and extract the mood of your customers, allowing you to react to potentially negative market developments early on.",
  },
  {
    img: ec5,
    alt: "Texts by Category",
    title: "Texts by Category",
    text: "Receive category texts/information texts about your products or services to create long lasting content for your website, improving your search engine ranking and attracting customers.",
  },
  {
    img: ec6,
    alt: "Texts with Glossaries",
    title: "Texts with Glossaries",
    text: "Request that ATUM Information Technology create unique glossary texts about the topics and terms you want to include on your website. As a result, provide content on your website that is appreciated by both search engines and customers, as well as convey your expertise.",
  },
  {
    img: ec7,
    alt: "Online Competitor Analysis",
    title: "Online Competitor Analysis",
    text: "We conduct online research on all freely available and desired data on your competitors, allowing you to monitor them and stay at least one step ahead.",
  },
  {
    img: ec8,
    alt: "Surveys",
    title: "Surveys",
    text: "Our crowd provides a large, global pool of survey participants to complete your surveys and provide feedback on products, ideas, and websites.",
  },
];

const ECommercePage = () => (
  <ServiceShell>
    {/* HERO */}
    <Hero
      chip="E-Commerce"
      title="E-Commerce Services"
      sub="Your ultimate business-companion"
      paragraphs={[
        "E-commerce, often known as electronic commerce, is the exchange of goods and services and sending of money and data through an electronic network, most commonly the internet. The e-commerce sector business dealings can be either B2B (business-to-business), B2C (business-to-consumer), C2C (consumer-to-consumer), or C2B.",
        "Increase your online earnings with new content, SEO, and data insights. As website operators, we are constantly faced with the challenge of monitoring the market and creating unique content with added value for the user on new product pages constantly being added. We can create, edit, or research thousands of data files in multiple languages for you in record time, thanks to our ATUM Information Technology network. Our experts can manage the e-commerce industry services very optimally.",
      ]}
      tags={["B2B", "B2C", "C2C", "C2B"]}
      img={newImg7}
      alt="E-commerce services"
    />

    {/* SERVICES */}
    <Section tint>
      <Intro chip="What We Do" title="Services Provided By Our E-Commerce Experts">
        <FeatureGrid items={services} cols={3} />
      </Intro>
    </Section>

    {/* COMPETITION */}
    <Section>
      <Split
        img={ECommerce}
        alt="E-commerce services"
        chip="Competition"
        title="Competitors And E-Commerce- The Vast Expansive Field."
        paragraphs={[
          "Competition is fierce in the eCommerce industry; offers are brief and transparent to the user. You can gain a competitive advantage while remaining visible in search engines and to users. ATUM Information Technology can help you provide all the necessary product data and interesting descriptions to every potential customer on your website. Furthermore, your store’s products and contents are classified and marked according to your store taxonomy to optimize your site’s filter and search functions. This ensures happy customers and top rankings in search engines like Google.",
        ]}
      />
    </Section>

    {/* USPs */}
    <Section tint>
      <Intro chip="Why Us" title="USPs To Choose E-Commerce Services From Our Firm!">
        <FeatureGrid items={usps} cols={4} />
      </Intro>
    </Section>

    <Cta
      chip="Get Started"
      title="Grow Your Online Store With ATUM Information Technology"
      paragraphs={[
        "Tell us about your store and we will recommend the right mix of content, data and search services to help it stand out.",
      ]}
    />
  </ServiceShell>
);

export default ECommercePage;